import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import CRUDgeneric from 'utils/CRUDgeneric';

export const baseURI = '/relojchecador/incidencia-reloj-checador/';

export const CRUDIncidenciaClock = CRUDgeneric('/relojchecador/guardar-incidencia/');
/**
 * GET Incidencia Reloj
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Reloj
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Reloj
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Reloj
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaReloj = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia Reloj
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const normalizeDataAreas = (_areasFetchArray) => {
  const mainMap = new Map();
  _areasFetchArray.forEach((item) => {
    mainMap.set(item.id, { ...item, children: [] });
  });

  const result = [];

  _areasFetchArray.forEach((item) => {
    if (item.directorio_area_padre) {
      const parent = mainMap.get(item.directorio_area_padre);
      if (parent) {
        parent.children.push(mainMap.get(item.id));
      }
    } else {
      result.push(mainMap.get(item.id));
    }
  });

  const sortByClave = (nodes) => {
    nodes.sort((a, b) => a.clave.localeCompare(b.clave));
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        sortByClave(node.children);
      }
    });
  };

  sortByClave(result);

  return result;
};

// Esta función adapta el árbol para que funcione con TreeSelect
export const formatTreeSelectData = (nodes) => nodes.map((node) => ({
  title: `${node.clave} - ${node.nombre.trim()}`,
  value: node.id,
  children: node.children ? formatTreeSelectData(node.children) : [],
}));
